import { Modal } from "@mui/material";
import React from "react";

function GraphicalAbstract({ open, handleClose }) {
  return (
    <Modal
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "auto",
      }}
      open={open}
      onClose={handleClose}
    >
      <img
        src="GA_v1.3.jpg"
        alt="Graphical Abstract"
        style={{ maxWidth: "90vw" }}
      />
    </Modal>
  );
}

export default GraphicalAbstract;
